import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  getPollingTableList,
  getPolls,
} from "../../redux/actions/pollingAction";
import DynamicTable from "../DynamicTable/DynamicTable";
import moment from "moment";
import { BASE_URL_PP } from "../../redux/api";
import { getPollResults } from "../../redux/actions/privateApiAction";
import { useNavigate, useSearchParams } from "react-router-dom";

const PollBadge = ({
  Dem_Candidate,
  GOP_Candidate,
  Result_Dem,
  Result_GOP,
  color1,
  color2
}) => {
  let dem_name = Dem_Candidate;
  let gop_name = GOP_Candidate;
  return (
    <div className="overflow-x-auto w-[20rem]">
      <table className="min-w-full  ">
        <tbody className="divide-y divide-transparent">
          <tr className="flex items-baseline">
            {/* Democratic Candidate */}
            <td className="flex-1 text-right pt-1">{dem_name ?? ""}</td>

            {/* Results Container */}
            <td className="flex-1 py-1 px-2 ">
              <div className="flex divide-x divide-transparent">
                {/* Democratic Result Button */}


                {/* Republican Result Button */}
                <button
                  style={{ backgroundColor: color2 }}
                  className="flex-1 align-middle select-none font-sans text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-1 px-0 text-nowrap text-white shadow-md focus:opacity-[0.85] active:opacity-[0.85] rounded-l-none"
                  type="button"
                >
                  {Result_Dem ?? 0}
                </button>

                <button
                  style={{ backgroundColor: color1 }}
                  className="flex-1 align-middle select-none font-sans text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs p-1 px-0 text-nowrap text-white shadow-md focus:opacity-[0.85] active:opacity-[0.85] rounded-r-none"
                  type="button"
                >
                  {Result_GOP ?? 0}
                </button>

              </div>
            </td>

            {/* Republican Candidate */}
            <td className="flex-1 text-left pt-1">{gop_name ?? ""}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

function PollingTable({ selectedYear }) {
  console.log("🚀 ~ PollingTable ~ selectedYear:", selectedYear)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { delhiElectionData } = useSelector((state) => state.pollWeb);
  console.log("🚀 ~ PollingTable ~ delhiElectionData:", delhiElectionData)
  const [candidateList, setCandidateList] = useState([]);
  const [candidate, setCandidate] = useState("");
  const [update, setUpdate] = useState(false);
  const isVerified = localStorage.getItem("accessToken");
  const currentDateTime = new Date();
  const type = searchParams.get("type");
  console.log("🚀 ~ PollingTable ~ type:", type)
  const { electoralVotesResponse } = useSelector(
    (state) => state?.pollWeb
  );
  const candidates = electoralVotesResponse || [];
  console.log("🚀 ~ PollingTable ~ candidates:", candidates)
  const colorMap = candidates.reduce((acc, item) => {
    acc[item.id] = item?.party?.color_code;
    return acc;
  }, {});
  const firstRow = delhiElectionData?.[0];
  const defaultDemColor = colorMap[firstRow?.DEM_CandidateId] || "#0042C9"; // blue
  const defaultRepColor = colorMap[firstRow?.REP_CandidateId] || "#fc0303";
  console.log("🚀 ~ PollingTable ~ colorMap:", colorMap)

  const dataList = {
    column: [
      {
        title: " DATES",
        field: "createdAt",
        customField: (row) =>
          row?.publish_date
            ? moment(row?.publish_date).format("DD/MM/YYYY")
            : "",
      },
      // {
      //   title: "SAMPLE",
      //   field: "",
      //   customField: (row) => row.poll_type_LV ?? row.poll_type_RV,
      // },
      {
        title: "POLLSTER",
        field: "pollster",
        customField: (row) => row.pollster ?? "-",
      },
      {
        title: "SPONSOR",
        field: "publisher",
        customField: (row) => row.publisher ?? "-",
        // customField: (row) => (row?.createdAt ? moment(row?.createdAt).format('MM/DD/YYYY, hh:mm A') : '')
      },
      {
        title: " POLL %",
        field: "",
        borderleft: true,
        customField: (row) => (
          <PollBadge
            Dem_Candidate={row?.dem_candidate}
            GOP_Candidate={row?.rep_candidate}
            Result_Dem={row?.dem_poll}
            Result_GOP={row?.rep_poll}
            color1={colorMap[row.REP_CandidateId] || defaultRepColor}
            color2={colorMap[row.DEM_CandidateId] || defaultDemColor}
          />
        ),
      },
      {
        title: " RESULT %",
        field: "",
        borderleft: true,
        customField: (row) => (
          <PollBadge
            Dem_Candidate={row?.dem_candidate}
            GOP_Candidate={row?.rep_candidate}
            Result_Dem={row?.dem_result}
            Result_GOP={row?.rep_result}
            color1={colorMap[row.REP_CandidateId] || defaultRepColor}
            color2={colorMap[row.DEM_CandidateId] || defaultDemColor}
          />
        ),
      },
      {
        title: "POLLSTER ACCURACY",
        field: "accuracies",
        customField: (row) => (
          <PollBadge
            // Dem_Candidate={row?.dem_candidate}
            // GOP_Candidate={row?.rep_candidate}
            Result_Dem={row?.dem_Accuracy}
            Result_GOP={row?.rep_Accuracy}
            color1={colorMap[row.REP_CandidateId] || defaultRepColor}
            color2={colorMap[row.DEM_CandidateId] || defaultDemColor}
          />
        ),
      },
      // {
      //   title: "NET RESULT",
      //   field: "result",
      //   customField: (row) => row?.result ?? 0,
      // },
    ],
  };
  const quary = `candidateName=${candidate}&year=${selectedYear}`;

  const pollPayload = type
    ? { country: localStorage.getItem("country") }
    : {
      country: localStorage.getItem("country"),
      state: localStorage.getItem("state")
    };
  const params = `type=poll_prediction&year=2025`;
  useEffect(() => {
    getCandidateList();
    if (quary) {
      dispatch(getPolls(pollPayload, quary));
    }
  }, [quary, candidate]);
  const country = localStorage.getItem("country");
  const state = localStorage.getItem("state");

  const getCandidateList = async () => {
    try {
      const response = await fetch(`${BASE_URL_PP}user/polls/candidate-list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({
          country: country,
          ...(!type && { state: state }),
        }),
      });

      const data = await response.json();
      if (data.status) {
        setCandidateList(data.data);
      } else {
        console.log(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handelCandidate = (e) => {
    const candidate = e.target.value;
    console.log("e.target.value ", e.target.value);

    setCandidate(candidate);
  };

  return (
    <div className="container mx-auto py-4 border rounded-md border-gray-200 capitalize">
      {/* Search and Dropdown */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 px-4">
        <div className="flex flex-col mb-4 md:mb-0">
          <div className="text-lg font-semibold pb-1"> polls</div>
          <div className="text-sm text-gray-500">
            Latest Poll:{" "}
            {/* {`${currentDateTime ? moment(currentDateTime).format("llll") : ""}`} */}
            {`${delhiElectionData?.[0]?.updatedAt
              ? moment(delhiElectionData?.[0]?.updatedAt).format("llll")
              : ""
              }`}
          </div>
        </div>

        {/* Dropdown Menu */}
        <div className="flex flex-col-reverse md:flex-row md:items-center gap-2 mb-4 md:mb-0">
          <div
            className="flex flex-row gap-2 align-middle"
            style={{ alignItems: "center" }}
          >
            <p className="text-sm font-medium uppercase text-gray-400 ">
              candidate
            </p>
            <select
              className="bg-[#E2E7EE] rounded-xl px-3 py-1.5 text-sm"
              onChange={(event) => handelCandidate(event)}
            >
              <option className="text-black" value="">
                All
              </option>
              {candidateList?.map((res, i) => {
                // console.log(candidateList?.[0]?.candidateName);

                return (
                  <option key={i} value={res?.candidateId}>
                    {res?.candidateName}
                  </option>
                );
              })}
              {/* <option className="text-black" value="jeo baden">
                jeo baden
              </option> */}
            </select>
          </div>

          {/* Search Bar */}
          {/* <div className="bg-gray-100 rounded-lg flex items-center gap-2 px-3 py-1.5">
            <FaSearch className="text-gray-600" />
            <div className="h-5 w-px bg-gray-300" />
            <input
              type="search"
              placeholder="Search Keyword"
              className="border-none outline-none text-xs bg-transparent rounded-md py-1 px-2 placeholder-gray-400"
            />
          </div> */}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        {delhiElectionData && delhiElectionData.length > 0 ? (
          <DynamicTable column={dataList?.column} data={delhiElectionData} />
        ) : (
          <div className="text-center text-gray-500 py-6 text-sm">
            No data available
          </div>
        )}
      </div>
    </div>
  );
}

export default PollingTable;
